import React, { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { QuoteContext } from "./QuoteContext";
import ApiService from "../../services/ApiService";
import { ShowErrorToast, ShowSuccessToast } from "../../components/toaster/toast";
import { motion } from "framer-motion";

const GetEmail = ({ closeModal }) => {
  const location = useLocation();
  const { formValues,resetQuoteForm } = useContext(QuoteContext);
  const { selectedCard, formData } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // Transform ages into members array
  // const members = formValues.ages?.map((age, index) => ({
  //   age,
  //   title: index === 0 ? "Primary" : `Member ${index}`,
  // })) || [];

  // Initialize formik
  const formik = useFormik({
    initialValues: {
      firstName: formData?.firstName || "",
      lastName: formData?.lastName || "",
      email: formData?.email || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name is required"),
      lastName: Yup.string().required("Last name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      setMessage("");

      const payload = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        members: formValues.ages,
        residency: formValues.residency.country,
        selectedPlans: formValues.selectedPlans,
        file: formValues.file,
        
      };

      console.log("Sending Data:", payload);

      try {
        // Await the API call to get the response
        const response = await ApiService.handleQuoteSubmission(payload);
        
        console.log("API Response:", response);

        // Ensure response is valid JSON
        if (response && response.success) {
          ShowSuccessToast("Quote submitted successfully!");
          resetQuoteForm();
        } else {
          ShowErrorToast(
            response?.message || "Error submitting quote. Please try again."
          );
        }
      } catch (error) {
        console.error("API Error:", error);
        setMessage("Server error. Please try again later.");
      }

      setLoading(false);
    },
  });

  return (
    <>
      <div className="float-right">
        <button
          onClick={closeModal}
          style={{
            fontSize: "20px",
            border: "none",
            background: "transparent",
            cursor: "pointer",
          }}
        >
          ✖️
        </button>
      </div>
      <div className=" md:p-8 flex flex-col items-center">
        {/* Form */}
        <form
          onSubmit={formik.handleSubmit}
          className="p-4 rounded-lg  w-full max-w-5xl bg-white "
        >
          {/* Heading */}
          <h2 className="text-lg md:text-xl font-bold mb-4 text-gray-500 text-center">
            To receive your quote via email, please fill in the details{" "}
            <br className="hidden md:block" /> below.{" "}
            <span className="text-orangeColor">- always happy to assist!</span>
          </h2>

          {/* Form Fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:gap-4 mb-6">
            {/* First Name Field */}
            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700">
                First Name
              </label>
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                value={formik.values.firstName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.firstName && formik.errors.firstName && (
                <div className="text-red-500 text-sm mt-1">
                  {formik.errors.firstName}
                </div>
              )}
            </div>

            {/* Last Name Field */}
            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700">
                Last Name
              </label>
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                value={formik.values.lastName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.lastName && formik.errors.lastName && (
                <div className="text-red-500 text-sm mt-1">
                  {formik.errors.lastName}
                </div>
              )}
            </div>

            {/* Email Field */}
            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700">
                Email address*
              </label>
              <input
                type="email"
                name="email"
                placeholder="To receive quote"
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.email && formik.errors.email && (
                <div className="text-red-500 text-sm mt-1">
                  {formik.errors.email}
                </div>
              )}
            </div>
          </div>

          {/* Disclaimer */}
          <p className="text-sm text-gray-600 mb-4 text-center md:text-left">
            By clicking 'Receive Details' you are agreeing to our{" "}
            <a href="#" className="text-blue-600 underline">
              Terms of Use
            </a>{" "}
            and{" "}
            <a href="#" className="text-blue-600 underline">
              Privacy Policy
            </a>
            .
          </p>

          {/* Buttons */}
          <div className="flex flex-col md:flex-row items-center justify-center md:justify-start gap-4">
            {/* <div className="flex items-center gap-1 px-4 py-2 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-50">
        <img src="/images/getemail/hf.png" alt="" className="h-5" />
        <button type="button" className="text-[13px]">Contact Me</button>
      </div> */}
            <div className="px-4 py-2 text-white flex bg-orangeColor justify-center w-full sm:w-auto border border-[#eb7b0c] items-center rounded-md gap-1">
              <img src="/images/getemail/ib.png" alt="" className="h-4" />
              <button type="submit" className="text-[13px]" disabled={loading}>
  {loading ? (
    <div className="flex gap-2">
      Submitting
      <motion.svg
        className="h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        animate={{ rotate: 360 }} // Rotating effect
        transition={{ repeat: Infinity, duration: 1, ease: "linear" }} // Continuous rotation
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8H4z"
        ></path>
      </motion.svg>
    </div>
  ) : (
    "Send Me the Quote"
  )}
</button>
            </div>
          </div>

          {/* Submission Message */}
          {message && (
            <p className="mt-4 text-lg text-blue-600 text-center">{message}</p>
          )}
        </form>
      </div>
    </>
  );
};

export default GetEmail;
